<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="360" min-width="320" max-width="320" nudge-bottom="8")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedPostcodes.length" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold Location
        .px-1.neutral400--text | 
        .text-xs.primary--text.font-medium {{ getpostcodes() }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold Location

    .pa-4.white
      .font-semibold.mb-3.text-sm {{ $t('filter_by') }} location
      v-row(dense align="center")
        v-col.shrink
          div.text-sm.neutral700--text Postcode
        v-col
          v-text-field.round-xl(v-model="postcodeInput" hide-details outlined dense placeholder="Eg: 43000")
        v-col.shrink
          y-button(label="Add" size="sm" outlined @click="addPostcode")

      template(v-if="postcodes.length")
        div.text-xs.font-semibold.neutral500--text.mt-2 Added:
        div
          template(v-for="(postcode, index) in postcodes")
            v-chip.mr-2.mt-2(label color="neutral300" close close-icon="mdi-close" @click:close="removePostcode(index)" :key="`${postcode}-${index}`") {{ postcode }}

    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(@click="clear" v-if="!disabledButton") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="disabledButton") {{ $t('apply') }}

</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      default: (() => {})
    },
    checkInitialValue: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data: () => ({
    showMenu: false,
    postcodeInput: null,
    postcodes: [],
    selectedPostcodes: [],
  }),
  computed: {
    disabledButton () {
      if (this.postcodes.length) {
        return false
      }
      return true
    }
  },
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) { this.clearData() }
      } 
    },
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      if (this.checkInitialValue) {
        if (this.filter.key) {
          this.selectedPostcodes = this.filter.value.split(',')
          this.postcodes = this.filter.value.split(',')
        }
      }
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.postcodes = []
      this.selectedPostcodes = []
    },
    addPostcode () {
      if (this.postcodeInput) {
        this.postcodes.push(this.postcodeInput)
        this.postcodeInput = null
      }
    },
    removePostcode (index) {
      this.postcodes.splice(index, 1)
    },
    apply () {
      this.showMenu = false
      this.selectedPostcodes = [...this.postcodes]
      this.$emit('update:filter', { key: 'postcodes', value: this.postcodes.join(',') })
    },
    getpostcodes () {
      const count = this.selectedPostcodes.length
      if (count <= 2) {
        return this.selectedPostcodes.join(', ')
      }
      return `${count} selected`
    },
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
</style>